import type { View } from '../router/router';
import { router } from '../router/router';
import { authService } from '../services/auth.service';
import { toast } from '../components/layout/toast';
import { $ } from '../utils/dom';
import { getDisciplineGymBrandHeader } from '../components/layout/brand-logo';
import { getTyrisIcon } from '../components/ui/tyris-icon';

export class LoginPage implements View {
  render(): string {
    return `
      <div class="login-wrapper">
        <div class="login-container">
          <div class="login-logo">
            ${getDisciplineGymBrandHeader({ size: 22, showSubtitle: true })}
          </div>
          
          <div class="card-glass">
            <form id="login-form" novalidate>
              <div class="form-group">
                <label for="email" class="form-label">Correo Electrónico</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  class="form-input" 
                  placeholder="nombre@ejemplo.com" 
                  required
                />
              </div>
              
              <div class="form-group" style="margin-bottom: 2rem;">
                <label for="password" class="form-label">Contraseña</label>
                <input 
                  type="password" 
                  id="password" 
                  name="password" 
                  class="form-input" 
                  placeholder="••••••••" 
                  required
                />
              </div>
              
              <button type="submit" id="btn-login-submit" class="btn btn-primary" style="width:100%;">
                ${getTyrisIcon('iniciar-sesion', { size: 18 })}
                <span>Iniciar Sesión</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    `;
  }

  afterRender(): void {
    const form = $('#login-form') as HTMLFormElement | null;
    const submitBtn = $('#btn-login-submit') as HTMLButtonElement | null;
    const emailInput = $('#email') as HTMLInputElement | null;
    const passwordInput = $('#password') as HTMLInputElement | null;

    if (!form || !submitBtn || !emailInput || !passwordInput) return;

    // Verificar si venimos con error de expiración de sesión
    const params = router.getParams();
    if (params.error === 'session_expired') {
      setTimeout(() => {
        toast.info('Tu sesión ha expirado por inactividad. Por favor, inicia sesión nuevamente.');
      }, 100);
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const email = emailInput.value.trim();
      const password = passwordInput.value;

      // 1. Validaciones básicas del lado del cliente
      if (!email) {
        toast.error('Por favor, ingresa tu correo electrónico.');
        emailInput.focus();
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        toast.error('El formato del correo electrónico ingresado no es válido.');
        emailInput.focus();
        return;
      }

      if (!password) {
        toast.error('Por favor, ingresa tu contraseña.');
        passwordInput.focus();
        return;
      }

      // 2. Estado de carga
      submitBtn.disabled = true;
      submitBtn.innerHTML = `
        ${getTyrisIcon('en-curso', { size: 18, style: 'animation: spin 1s linear infinite' })}
        <span>Autenticando perfil...</span>
      `;
      emailInput.disabled = true;
      passwordInput.disabled = true;

      try {
        const response = await authService.login(email, password);
        toast.success(`¡Bienvenido de vuelta, ${response.user.firstName}!`);
        
        // Redirigir
        window.location.hash = '#/dashboard';
      } catch (err: any) {
        console.error('Error de login:', err);
        
        // Restaurar controles en caso de error
        submitBtn.disabled = false;
        submitBtn.innerHTML = `
          ${getTyrisIcon('iniciar-sesion', { size: 18 })}
          <span>Iniciar Sesión</span>
        `;
        emailInput.disabled = false;
        passwordInput.disabled = false;

        const errorMsg = err.body?.message || err.message || 'Credenciales inválidas o error de conexión.';
        toast.error(errorMsg);
      }
    });
  }
}
